module.exports = __webpack_public_path__ + "static/media/left_att_freq.6c54dda0.png";